// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mockup: false,

  // AUTH_SERVICE_ENDPOINT: 'http://100.65.32.80:8080/cpha-auth',
  // API_SERVICE_ENDPOINT: 'http://100.65.32.80:8080/cps-api'
  // let the proxy server handle the port redirect otherwise we won't be able
  // to take advantage of the load balancer
  AUTH_SERVICE_ENDPOINT: '/cpha-auth',
  API_SERVICE_ENDPOINT: '/cps-api',
  PROXY_SERVICE_ENDPOINT: '/cps-proxy',
  HUB_ENDPOINT: 'https://hub-staging.pharmacists.ca',
  CPS2_DOMAIN: 'https://cps-staging.pharmacists.ca/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
